export default __webpack_public_path__ + "static/media/VISUAL_ARTS.bd72f8f8.svg";